// extracted by mini-css-extract-plugin
export var fadeIn = "_da-1";
export var modalContent = "_da-3";
export var overlay = "_da-0";
export var popoverContent = "_da-2";
export var results = "_da-5";
export var searchInputWrapper = "_da-4";